/* src/app/public/reset/reset.component.scss */
.login-form {
  height: 100vh;
  overflow: hidden;
  background: #fff;
  overflow-y: auto;
}
.row {
  height: 100vh;
  background-color: #fff;
}
li {
  font-weight: 500;
}
.leftSide {
  background: url("./media/leftimg.jpg");
  background-size: cover;
  background-repeat: no-repeat;
}
.rightSide {
  background: url("./media/rightimg.png");
  background-size: cover;
  position: relative;
}
.middleContainer {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
  width: 60%;
}
.tina {
  height: 320px;
  object-fit: contain;
}
.logo {
  width: 360px;
  height: 76px;
  object-fit: contain;
}
.heading {
  font-family: Inter;
  font-size: 37px;
  font-weight: 500;
  line-height: 15px;
  letter-spacing: 0em;
  text-align: center;
  color: #092B61;
  margin-top: 47px;
}
.subheading {
  font-family: Inter;
  font-size: 22px;
  font-weight: 500;
  line-height: 29px;
  letter-spacing: 0em;
  text-align: center;
  color: #092B61;
  margin-top: 5px;
}
.inputdiv {
  width: 100%;
}
.form-control {
  border-radius: 5px;
  color: #092B61;
}
.form-control:hover {
  box-shadow: 9px 10px 7.5px 2px rgba(0, 0, 0, 0.2509803922);
}
.form-control:focus {
  border: none;
  outline: none;
  box-shadow: none;
}
.label {
  color: #fff;
}
.login-button {
  background: #F07A0C;
  border-radius: 30px;
  color: #fff;
  margin-top: 49px;
  padding: 10px 40px;
  border: none;
  font-size: 17px;
}
.login-button:hover {
  box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.2509803922);
}
.login-text {
  color: #fff;
  font-family: Inter;
  font-size: 38px;
  font-weight: 600;
  letter-spacing: 0em;
  text-align: left;
  margin-bottom: 83px;
  margin-top: -83px;
}
.forgetpass {
  font-family: Inter;
  font-size: 16px;
  font-weight: 700;
  line-height: 19px;
  letter-spacing: 0em;
  text-align: left;
  color: #fff;
  margin-top: 30px;
  cursor: pointer;
}
.otpbox {
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;
  height: 100%;
  width: 60%;
  display: flex;
  justify-content: center;
  align-items: center;
}
.mtErr {
  margin-left: 0px;
  color: red;
  font-weight: 600;
}
.input-text {
  box-shadow: 9px 10px 7.5px 2px rgba(0, 0, 0, 0.2509803922);
  border-radius: 30px;
  background: #fff !important;
  padding: 10px 17px;
}
.p-inputotp {
  gap: 2rem;
}
.p-password {
  box-shadow: 9px 10px 7.5px 2px rgba(0, 0, 0, 0.2509803922) !important;
  border-radius: 30px !important;
  background: #fff !important;
  padding: 10px 17px !important;
  width: 100% !important;
}
.p-password-input {
  box-shadow: 9px 10px 7.5px 2px rgba(0, 0, 0, 0.2509803922) !important;
  border-radius: 30px !important;
  background: #fff !important;
  padding: 10px 17px !important;
  width: 100% !important;
}
.p-password-toggle-mask-icon {
  margin-right: 10px !important;
}
.left-logo-screen {
  display: none;
}
@media only screen and (max-width: 998px) {
  .left-logo-screen {
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  .logo {
    height: 50px;
    margin-top: 50px;
  }
  .row {
    overflow-y: scroll;
  }
  .row::-webkit-scrollbar {
    display: none;
  }
  .tina {
    width: 200px;
    height: auto;
    margin-top: 30px;
  }
  .heading {
    font-size: 25px;
    margin-top: 10px;
  }
  .middleContainer {
    justify-content: flex-start;
  }
  .subheading {
    font-size: 19px;
    margin-top: -12px;
  }
  .leftSide {
    margin-top: 60px;
  }
  .leftSide {
    background: url("./media/leftimg.png");
  }
  .rightSide {
    background: url("./media/leftimg.png");
    padding-top: 50px;
    padding-top: 50px;
    background-size: cover;
    background-position: revert;
    margin-top: -2px;
    height: 500px;
  }
  .login-text {
    color: #000;
    text-align: center;
    font-weight: bold;
    font-size: 30px;
    margin-bottom: 21px;
    margin-top: -40px;
  }
  .login-button {
    margin-top: 20px;
  }
  .forgetpass {
    margin-top: 15px;
    color: #000;
  }
}
@media only screen and (max-width: 500px) {
  .middleContainer {
    width: 90%;
  }
}
.passwordClass {
  box-shadow: 9px 10px 7.5px 2px rgba(0, 0, 0, 0.2509803922) !important;
  border-radius: 30px !important;
  padding: 10px 20px !important;
}
/*# sourceMappingURL=reset.component.css.map */
